import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { CardAvatar } from '@sorare/core/src/components/card/Avatar';

import type { Props as BaseSlotContentProps } from '#src/components/missions/picker/TaskCardsPicker/index.tsx';
import { BaseSlotContent } from '#src/components/missions/picker/TaskCardsPicker/index.tsx';

import type { BaseSlot_anyCardInterface } from './__generated__/index.graphql.ts';

type Props = BaseSlotContentProps & {
  card?: BaseSlot_anyCardInterface;
};

export const BaseSlot = ({ card, children, ...rest }: Props) => {
  return (
    <BaseSlotContent {...rest}>
      {card ? (
        <CardAvatar card={card} maxWidth={40} noTitle />
      ) : (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none">
          <g clipPath="url(#clip0_21515_917)">
            <rect
              width="32"
              height="32"
              rx="16"
              fill="currentColor"
              fillOpacity="0.07"
            />
            <path
              d="M32 25.8078C31.6092 25.1369 31.02 24.4665 30.1518 24.1813C29.5755 23.8973 24.6292 21.8541 22.2282 20.868C22.0008 20.7186 21.5341 20.0974 21.1605 19.6002C20.9423 19.3099 20.756 19.0618 20.6674 18.9745C20.4754 18.785 20.5074 16.8446 20.5474 15.8981C20.5874 15.3064 20.7875 14.4779 20.7875 14.4779C22.1081 14.0048 22.2282 11.7565 22.2282 11.7565C22.5163 10.6205 21.6279 10.5732 21.2677 11.0463V9.38988C21.2677 9.29522 21.1076 7.6938 21.0276 6.90493C21.0276 5.56384 19.4669 3.35499 16.2254 3C12.3837 3.09467 11.2632 5.64273 11.1831 6.90493L11.1831 9.27155L11.3032 11.0463C10.983 10.3758 10.3427 10.6915 10.3427 11.638C10.3427 13.7206 11.3832 14.3991 11.9035 14.4779C12.0635 14.9118 12.4077 15.8979 12.5037 16.3712C12.5998 16.8446 12.4637 18.304 12.3837 18.9745L11.4232 20.7495C9.30227 21.5384 4.72419 23.2344 3.37958 23.7078C2.03497 24.1811 1.05852 25.6405 0.738376 26.3111L1.1954e-07 28.0286L0 31.9232C-5.21573e-08 33.6225 1.43269 35 3.2 35H28.8C30.5673 35 32 33.6225 32 31.9232L32 25.8078Z"
              fill="currentColor"
              fillOpacity="0.07"
            />
          </g>
          <rect
            x="0.4"
            y="0.4"
            width="31.2"
            height="31.2"
            rx="15.6"
            stroke="#2A2A2A"
            strokeOpacity="0.17"
            strokeWidth="0.8"
          />
          <defs>
            <clipPath id="clip0_21515_917">
              <rect width="32" height="32" rx="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )}
      {children}
    </BaseSlotContent>
  );
};

BaseSlot.fragments = {
  anyCardInterface: gql`
    fragment BaseSlot_anyCardInterface on AnyCardInterface {
      slug
      ...CardAvatar_anyCard
    }
    ${CardAvatar.fragments.anyCard}
  ` as TypedDocumentNode<BaseSlot_anyCardInterface>,
};
